export default __webpack_public_path__ + "static/media/analysis1.f027d01d.svg";